<template>
  <!-- Broadcasts posted for AIM IT Services (internal staff) — Jobs + Tickets Summary pages -->
  <div v-if="internalBroadcasts.length" class="space-y-2 mb-3">
    <div v-for="b in internalBroadcasts" :key="b.id"
      class="rounded-lg border-2 p-3 flex items-start gap-3 shadow"
      :class="b.type === 'outage'
        ? 'border-red-500 bg-red-50 dark:bg-red-900/30'
        : 'border-blue-500 bg-blue-50 dark:bg-blue-900/30'">
      <div class="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-white font-bold"
        :class="b.type === 'outage' ? 'bg-red-500' : 'bg-blue-600'">!</div>
      <div class="flex-1 min-w-0">
        <h4 class="text-sm font-semibold text-gray-900 dark:text-gray-100 flex items-center gap-2 flex-wrap">
          {{ b.subject }}
          <span class="rounded-full px-2 py-0.5 text-xs font-bold text-white uppercase"
            :class="b.type === 'outage' ? 'bg-red-500' : 'bg-blue-600'">
            {{ b.type === 'outage' ? 'Outage' : 'Notice' }}
          </span>
          <span class="rounded-full px-2 py-0.5 text-xs font-semibold bg-gray-200 text-gray-700 dark:bg-gray-600 dark:text-gray-100">
            Internal
          </span>
          <a v-if="b.ticket_id" :href="`/ticket/${b.ticket_id}`" target="_blank"
            class="text-xs font-normal text-blue-600 hover:underline dark:text-blue-300">#{{ b.ticket_id }}</a>
        </h4>
        <p class="text-xs text-gray-700 dark:text-gray-200 mt-1 whitespace-pre-line">{{ b.message }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import BroadcastService from '@/services/BroadcastService';

const props = defineProps({
  // Pass the page's already-loaded live broadcasts to skip a second fetch;
  // leave unset and the banner loads them itself.
  broadcasts: { type: Array, default: null },
});

const loaded = ref([]);

// `internal` is only set for internal-scope viewers, so others never see a banner.
const internalBroadcasts = computed(() => (props.broadcasts ?? loaded.value).filter(b => b.internal));

onMounted(async () => {
  if (props.broadcasts !== null) return;
  try {
    const { data } = await BroadcastService.getActive();
    loaded.value = Array.isArray(data) ? data : (data.data || []);
  } catch (e) {
    // Non-fatal — the page works without the banner.
  }
});
</script>
